import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  getAgentSkills: {
    url: 'api/agent/skills/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      include_sessions: [NetworkParamType.boolean],
      namespace: [NetworkParamType.string],
    },
  },
  createAgentSession: {
    url: 'api/agent/sessions/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      skill_type: [NetworkParamType.string],
      title: [NetworkParamType.string],
      context: [NetworkParamType.object],
    },
  },
  getAgentSession: {
    url: 'api/agent/sessions/{session_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
  },
  getAgentSessionRelatedSessions: {
    url: 'api/agent/sessions/{session_id}/related-sessions/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
  },
  patchAgentSession: {
    url: 'api/agent/sessions/{session_id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'patch',
    params: {
      artifact: [NetworkParamType.string],
      context: [NetworkParamType.object],
      is_open: [NetworkParamType.boolean],
      title: [NetworkParamType.string],
    },
  },
  getAgentSessionContext: {
    url: 'api/agent/sessions/{session_id}/context/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
  },
  getAgentSessionContextOptions: {
    url: 'api/agent/sessions/{session_id}/context-options/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
  },
  createAgentSessionMessage: {
    url: 'api/agent/sessions/{session_id}/messages/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      role: [NetworkParamType.string],
      message: [NetworkParamType.string],
    },
  },
  getAgentSessionStatus: {
    url: 'api/agent/sessions/{session_id}/status/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
  },
  runAgentSessionAction: {
    url: 'api/agent/sessions/{session_id}/actions/{action}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
  },
  resetAgentSession: {
    url: 'api/agent/sessions/{session_id}/reset-session/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
  },
  closeAgentSessionChain: {
    url: 'api/agent/sessions/{session_id}/close-chain/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
  },
};
